import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

interface IBarChartProps {
	chartData: any;
	chartOptions: any;
}

interface IChartData {
	name: string;
	data: (number | null)[];
}

const BarChart = (props: IBarChartProps) => {
	const [chartData, setChartData] = useState<IChartData[]>([]);
	const [chartOptions, setChartOptions] = useState({});

	useEffect(() => {
		setChartData(props.chartData);
		setChartOptions(props.chartOptions);
	}, [props]);
	return (
		<ReactApexChart
			options={chartOptions}
			series={chartData}
			type='bar'
			width='90%'
			height='300px'
		/>
	);
};

export default BarChart;
